module.exports = __webpack_public_path__ + "static/media/logo_uno_full_azul.376240ce.svg";